// @flow
import React from 'react';
import {StyleSheet, Image, View, TouchableOpacity, Linking} from 'react-native';
import {EmphasizedSubText} from 'trpc-react-native-ui';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import config from '../../config';

const DownloadAppOnStore = () => {
  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <Image
          style={styles.icon}
          source={theme.eSimImage}
          resizeMode="contain"
        />
      </View>

      <View style={styles.textContainer}>
        <EmphasizedSubText
          style={styles.text}
          emphStyle={styles.textBold}
          text={I18n.t('SignUp.SimOrEsim.downloadAppText')}
        />
      </View>

      <View style={styles.storeButtonsContainer}>
        <TouchableOpacity
          style={styles.storeButton}
          onPress={() =>
            Linking.openURL(config.GOOGLE_PLAYSTORE_WIZZEE_LINK)
          }>
          <Image
            style={styles.storeImage}
            source={theme.downloadPlayStoreImage}
            resizeMode="contain"
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.storeButton}
          onPress={() =>
            Linking.openURL(config.APPLE_APPSTORE_WIZZEE_LINK)
          }>
          <Image
            style={styles.storeImage}
            source={theme.downloadAppStoreImage}
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
    paddingVertical: 20,
    paddingHorizontal: 16,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#EEEEEE',
  },
  iconContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
  },
  icon: {
    width: 80,
    height: 80,
  },
  textContainer: {
    flex: 1,
    minWidth: 200,
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  text: {
    color: theme.signUpInputTextColor,
    fontSize: 16,
    lineHeight: 24,
    fontFamily: 'Gotham',
    textAlign: 'center',
  },
  textBold: {
    fontWeight: '700',
    fontSize: 16,
  },
  storeButtonsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 8,
  },
  storeButton: {
    margin: 6,
  },
  storeImage: {
    width: 130,
    height: 52,
  },
});

export default DownloadAppOnStore;
